export default __webpack_public_path__ + "static/media/IconDesc_Wire.256.7f69d42c.png";